import { Alignment } from './Alignment';

export enum SlotType {
  SINGLE = 'SINGLE',
  PAIR = 'PAIR',
  LINE = 'LINE'
}

export interface BaseDefinitionSlot {
  name: string;
}

export interface SingleSlotDefinition extends BaseDefinitionSlot {
  type: SlotType.SINGLE;
  xIndex?: number;
  yIndex?: number;
  alignment: Alignment;
}

export interface SlotPairDefinition extends BaseDefinitionSlot {
  type: SlotType.PAIR;
}

export interface SlotLineDefinition extends BaseDefinitionSlot {
  type: SlotType.LINE;
  length: number;
  axis: 'X' | 'Y' | 'Z';
}

export type SlotDefinition = SingleSlotDefinition | SlotPairDefinition | SlotLineDefinition;

export function isSlotLineDefinition(
  slotDefinition: SlotDefinition
): slotDefinition is SlotLineDefinition {
  return slotDefinition.type === SlotType.LINE;
}
